import { render, staticRenderFns } from "./p_header.vue?vue&type=template&id=098fc8f0&scoped=true&"
import script from "./p_header.vue?vue&type=script&lang=js&"
export * from "./p_header.vue?vue&type=script&lang=js&"
import style0 from "./p_header.vue?vue&type=style&index=0&id=098fc8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098fc8f0",
  null
  
)

export default component.exports